import {Subject} from 'rxjs';
import {filter} from 'rxjs/operators';

const createEventEmitter = <TEventType>() => {
  const bus = new Subject<{type: TEventType}>();

  const emit = (type: TEventType) => {
    bus.next({type});
  };

  const on = (type: TEventType, listener: () => void) => {
    const subscription = bus.pipe(filter((e) => e.type === type)).subscribe(listener);

    return () => subscription.unsubscribe();
  };

  const destroy = () => {
    bus.complete();
  };

  return {emit, on, destroy};
};

export {createEventEmitter};
